import React from "react";
import EligibleProducts from "src/components/pages/eligibleProduct/desktop/eligibleProducts";
import SortCenterProducts from "src/components/pages/eligibleProduct/desktop/sortCenterProducts";
import { doesSiteBelongToSortCenter } from "src/components/shared/utils/utils";
import useSiteCodeContext from "src/components/shared/context/useSiteCodeContext";

const DesktopProductIndex = () => {
  const siteCode = useSiteCodeContext();
  const isSortCenter = doesSiteBelongToSortCenter(siteCode);

  if (isSortCenter) {
    return <SortCenterProducts></SortCenterProducts>;
  }

  return <EligibleProducts></EligibleProducts>;
};

export default DesktopProductIndex;
